/**
 * Hook para sincronización con Google Sheets
 * Proporciona funcionalidad de sincronización automática para reemplazar exportación Excel
 */

import { useState, useCallback } from 'react';

export function useGoogleSheetsSync() {
  const [syncing, setSyncing] = useState(false);
  const [lastSync, setLastSync] = useState(null);
  const [syncError, setSyncError] = useState(null);

  const syncTransactions = useCallback(async (transactions) => {
    setSyncing(true);
    setSyncError(null);

    try {
      // Verificar que tenemos transacciones
      if (!transactions || transactions.length === 0) {
        throw new Error('No hay transacciones para sincronizar');
      }

      console.log('Iniciando sincronización de', transactions.length, 'transacciones con Google Sheets');
      
      // Llamar al endpoint del servidor para sincronizar con Google Sheets
      // Usa únicamente service-account.json para autenticación, sin requerir login de usuario
      const response = await fetch('/api/sync-google-sheets', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ transactions })
      });

      const result = await response.json();
      
      if (!response.ok) {
        throw new Error(result.error || `Error HTTP: ${response.status}`);
      }

      if (!result.success) {
        throw new Error(result.error || 'Sincronización falló sin mensaje de error');
      }
      
      setLastSync(new Date());
      
      return result;

    } catch (error) {
      console.error('Error en sincronización Google Sheets:', error);
      setSyncError(error.message);
      
      return {
        success: false,
        error: error.message
      };
    } finally {
      setSyncing(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setSyncError(null);
  }, []);

  return {
    syncTransactions,
    syncing,
    lastSync,
    syncError,
    clearError
  };
}